<template>
  <session class="mobile-page-header">
    <LeftNavs />
    <!-- <div class="page-headerl"><Icon name="category" size="18" /></div> -->
    <div class="page-headerr">
      <div class="page-headerrl">
        <div class="langs" @click="showoptions=true;">
          <Icon name="lang" size="18" /><span :class="{ ffen: getLocalLangCode() != 'zh' }">{{curLang?.label}}</span>
        </div>
        <div class="items">
          <div class="item" @click="Utils.loginDialogToggle(true)"><Icon name="user" size="18" /></div>
          <div class="item" @click="Utils.loginDialogToggle(true,'person')"><Icon name="gift-b" size="28"/></div>
        </div>
      </div>
      <div class="page-headerrr" @click="Utils.toTargetPage('/')">
        <img src="@/assets/images/logo-en.svg" v-if="!curLang?.code || curLang?.code == 'en'" />
        <img src="@/assets/images/logo.svg" v-if="curLang?.code == 'zh'" />
        <img src="@/assets/images/logo-jp.svg" v-if="curLang?.code == 'jp'" />
        <img src="@/assets/images/logo-kr.svg" v-if="curLang?.code == 'kr'" />
      </div>
    </div>
  </session>

  <t-popup :overlayProps="{ backgroundColor: 'rgba(255,255,255,0.1)' }" v-model="showoptions" placement="bottom" v-if="langList?.length > 0" class="header-lang-wrap">
    <t-picker
      :defaultValue="[curLang?.code]"
      :columns="langList"
      :option="option"
      @confirm="(val) => {
        showoptions = false
        selectLang({ code: val })
      }"
      @cancel="showoptions = false"
    />
  </t-popup>
</template>

<script setup>
  import { onMounted, ref } from 'vue';
  import Icon from '@/components/icon/index.vue';
  import LeftNavs from '@/mobile/components/leftnavs/index.vue';
  import * as Utils from '@/assets/utils';
  import { getLangList, getLocalLang, setLocalLangCode, getLocalLangCode } from '@/assets/lang/index';

  /**
   * 多语言
   */
  const showoptions = ref(false);
  const langList = ref([])
  const curLang = ref(null);
  const init = () => {
    langList.value = getLangList();

    curLang.value = getLocalLang();
    console.log('curLang.value', curLang.value.code, ', curLang.value.code', curLang.value.value)
  }
  onMounted(() => {
    init();
  })
  const selectLang = data => {
    setLocalLangCode(data?.code);
    window.location.reload();
  }

  // 登录
  const showLogin = ref(false);
</script>

<style scoped lang="less">
  @import "index.less";
</style>

<style lang="less">
  .header-lang-wrap{
    --td-picker-button-font-size: 14px;
    --td-picker-indicator-bg-color: #f0f4fc;
    --td-picker-item-active-color: #6A95D9;
  }
</style>